import { create } from "zustand";
import { Album, Playlist } from "../types";
import { useLocalLibraryStore } from "./localLibraryStore";

interface SidebarState {
  isOpen: boolean;
  toggleSidebar: () => void;
  closeSidebar: () => void;
  getRecentPlaylists: (limit?: number) => Playlist[];
  getRecentAlbums: (limit?: number) => Album[];
}

export const useSidebarStore = create<SidebarState>((set, get) => ({
  isOpen: false,
  toggleSidebar: () => set((state) => ({ isOpen: !state.isOpen })),
  closeSidebar: () => set({ isOpen: false }),
  getRecentPlaylists: (limit = 5) => {
    const localLibrary = useLocalLibraryStore.getState();
    return localLibrary.getAllPlaylists().slice(0, limit);
  },
  getRecentAlbums: (limit = 5) => {
    const localLibrary = useLocalLibraryStore.getState();
    return localLibrary.getAllAlbums().slice(0, limit);
  },
}));
